import { createStore } from "vuex";
import minersModule from "./miners/index";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    miners: minersModule,
  },
});
